import React, { useEffect, useState, useContext } from "react";
import { DContext } from "../../../context/Datacontext";
import { useNavigate } from "react-router-dom";

export default function TopCourses() {

    const { BeURL } = useContext(DContext);
    const [courses, setCourses] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        fetch(`${BeURL}/top-enroll-course-in-instructor`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                setCourses(data.data || []);
            });

    }, [BeURL]);

    return (
        <div className="bg-white rounded-2xl p-6">
            <div className="flex justify-between items-center">
                <p className="text-sm font-medium mb-4">
                    Recent Orders Courses
                </p>
                <button onClick={() => navigate('/instructor/orders')} className="underline text-primary-600">See all</button>
            </div>

            <ul className="space-y-3">
                {courses.map((course, index) => (
                    <li key={course._id}
                        className="flex items-center gap-3">
                        <div
                            className="w-9 h-9 rounded-lg bg-indigo-50 flex items-center justify-center font-semibold"
                        >
                            {index + 1}
                        </div>
                        <div>
                            <p className="text-sm">
                                {course?.course?.title}
                            </p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}